import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import SectionHeading from '../../Common/SectionHeading'
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { Navigation, Autoplay, EffectCoverflow } from 'swiper/modules';

export default function ReportSliderSection({ data = null, title }) {
    return (
        <>
            {(data) &&
                <>
                    <div className="w-11/12 mx-auto my-6 xl:max-w-screen max-w-screen-2xl lg:my-10">
                        <SectionHeading
                            title={title}
                            customClass="text-center"
                        />
                        <Swiper
                            modules={[Navigation, Autoplay, EffectCoverflow]}
                            speed={300}
                            effect={'coverflow'}
                            grabCursor={true}
                            centeredSlides={true}
                            slidesPerView="5"
                            coverflowEffect={{
                                rotate: 0,
                                stretch: 1,
                                depth: 200,
                                modifier: 1,
                                slideShadows: true,
                            }}
                            loop={true}
                            autoplay={{
                                delay: 3000,
                            }}
                            breakpoints={{
                                680: {
                                    slidesPerView: 5,
                                    spaceBetween: 10,
                                },
                                765: {
                                    slidesPerView: 5,
                                    spaceBetween: 20,
                                },
                                1024: {
                                    slidesPerView: 5,
                                    spaceBetween: 10,
                                },
                            }}
                            className="mySwiper">
                            {data?.map((item, index) => (
                                <SwiperSlide key={index}>
                                    <Link className='relative' href={process.env.APP_URL+item?.link}>
                                        <Image
                                            className="w-full h-full md:w-60"
                                            priority={true}
                                            src={process.env.IMG_CDN + item?.imagSrc}
                                            alt={item?.altText ? item?.altText : item?.title ? item?.title : 'DelveInsight'}
                                            width={2000}
                                            height={2000}
                                        />
                                        {process.env.IS_SALE == 'active'  && (
                                            <div className='absolute top-0 left-0 px-2 py-3 text-xs font-semibold text-white bg-red-600 rounded-full'> SALE </div>
                                        )}
                                    </Link>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </>
            }
        </>
    )
}
